<template>
    <div class="headerimagelayout">
        <svg class="group" width="78" height="95" viewBox="0 0 78 95" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3835_735)">
            <g opacity="0.2">
            <path d="M0.0820312 65.8321C11.2406 31.8934 58.9713 23.896 60.9848 -10.1836C47.2974 16.0355 0.718281 24.6934 0.0820312 65.8321Z" fill="#27B6F4"/>
            <path d="M68.6948 -14C68.7512 -12.1033 68.7673 -12.349 68.5136 -10.2389C63.625 30.6019 20.1224 33.7912 9.58402 64.6694C3.31011 83.0522 12.3062 95 35.8635 95C25.3735 92.2698 15.1975 89.8536 15.4431 76.8105C15.717 62.6197 35.0944 50.6156 52.0033 36.9724C56.1027 33.6664 59.8638 30.3562 63.2343 26.9817C79.3903 8.66739 72.6573 -9.15162 68.6908 -14H68.6948Z" fill="#27B6F4"/>
            </g>
            </g>
            <path opacity="0.3" d="M77.5775 70.8815C65.9013 68.7296 57.528 59.8296 56.1295 48H55.5403C54.2251 59.8004 45.9827 68.7179 34.4315 71.0043C33.8483 71.1213 33.8602 71.9283 34.4434 72.0277C45.4531 73.9749 53.624 81.8633 55.8081 92.5819C55.9212 93.1433 56.7543 93.1374 56.8614 92.576C58.9265 81.9685 66.8416 74.0977 77.5715 71.9224C78.1428 71.8055 78.1428 70.9868 77.5715 70.8815H77.5775Z" fill="#26B0EB"/>
            <defs>
            <clipPath id="clip0_3835_735">
            <rect width="74" height="95" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    </div>
  </template>
  
  <style>
  .headerimagelayout {
    height: 95px;
    position: relative;
    width: 74px;
  }
  
  .headerimagelayout .group {
    height: 95px;
    left: 0;
    position: absolute;
    top: 0;
    width: 73px;
  }
  </style>